
(async function () {
    const mapElements = document.querySelectorAll("[data-gmap-apikey]");
    if (mapElements.length) {
        (g => { var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window; b = b[c] || (b[c] = {}); var d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams, u = () => h || (h = new Promise(async (f, n) => { await (a = m.createElement("script")); e.set("libraries", [...r] + ""); for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]); e.set("callback", c + ".maps." + q); a.src = `https://maps.${c}apis.com/maps/api/js?` + e; d[q] = f; a.onerror = () => h = n(Error(p + " could not load.")); a.nonce = m.querySelector("script[nonce]")?.nonce || ""; m.head.append(a) })); d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)) })({
            key: mapElements[0].dataset.gmapApikey,
            v: "weekly",
        });
        await setUpMaps(mapElements)
    }
    async function setUpMaps(mapElements) {
        const { Map, InfoWindow } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
        mapElements.forEach((map) => {
            const mapContainer = map.querySelector(".googlemap")
            if (mapContainer) {
                const lat = parseFloat(map.dataset.lat)
                const lng = parseFloat(map.dataset.lng)
                const zoom = parseFloat(map.dataset.zoom)
                const markertitle = map.dataset.markertitle

                const height = map.dataset.height
                mapContainer.style.height = height;
                mapContainer.style.width = "100%";
                const position = { lat: lat, lng: lng }

                const googleMap = new Map(mapContainer, {
                    center: position,
                    zoom: zoom,
                    mapId: "9ea9bb3c4b5b7fdeefdf6ceb"
                });

                new AdvancedMarkerElement({
                    map: googleMap,
                    position: position,
                    title: markertitle
                });

            }
        })

    }
})();

